import { createContext, useContext } from 'react';
export interface User { id: string; name: string; email?: string; role: 'admin' | 'agent' | 'compliance' | 'viewer'; kind?: string }
export const AuthCtx = createContext<{ user: User | null; logout: () => void }>({ user: null, logout: () => undefined });
export const useAuth = () => useContext(AuthCtx);
export const canWrite = (u: User | null, roles: User['role'][] = ['agent', 'compliance']) => !!u && (u.role === 'admin' || roles.includes(u.role));
